import { useTheme } from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TooltipContent } from 'foundations-components/transitional/components/Tooltip';
import { INTEGRATION_STATUS } from '../constants';
import { ErrorsType } from '../../common/constants/commonConstants';
import { errorLabels } from '../../common/utils/errorUtils';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import LabelWithTooltip from '../../common/components/LabelWithTooltip';
import I18n from 'I18n';
import TooltipSelect from '../../common/components/TooltipSelect';
import { StatusTag as FoundationsStatusTag } from 'foundations-components/transitional/components/StatusTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const IntegrationDisconnectTooltip = ({
  errorLabel,
  appName
}) => {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsxs(TooltipContent, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        fontWeight: trellisTheme.typography['heading-1000'].fontWeight,
        fontSize: trellisTheme.typography['heading-50'].fontSize
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: errorLabel.title,
        options: {
          appName
        }
      })
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: errorLabel.message,
      elements: {
        Link
      },
      options: {
        href: errorLabel.link,
        external: true
      }
    })]
  });
};
const StatusTag = ({
  statusType,
  integrationStatus
}) => /*#__PURE__*/_jsx(FoundationsStatusTag, {
  use: statusType,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `videoConference.settings.webinarsForm.webinarIntegrationSelect.integrationStatus.${integrationStatus}`
  })
});
const IntegrationSelection = ({
  appStatusData,
  webinarSource,
  onWebinarSource
}) => {
  const buildHelpOption = appStatus => {
    switch (appStatus) {
      case INTEGRATION_STATUS.CONNECTED:
        return /*#__PURE__*/_jsx(StatusTag, {
          statusType: "success",
          integrationStatus: INTEGRATION_STATUS.CONNECTED
        });
      case INTEGRATION_STATUS.DISCONNECTED:
      case INTEGRATION_STATUS.CONNECTION_ERROR:
        return /*#__PURE__*/_jsx(StatusTag, {
          statusType: "error",
          integrationStatus: INTEGRATION_STATUS.CONNECTION_ERROR
        });
      default:
        return /*#__PURE__*/_jsx(_Fragment, {});
    }
  };
  const buildIntegrationOptions = () => {
    return appStatusData.map(({
      appName,
      appId,
      iconUrl,
      appStatus
    }) => {
      const isDisconnect = appStatus !== INTEGRATION_STATUS.CONNECTED;
      return {
        text: appName,
        value: appId.toString(),
        imageUrl: iconUrl,
        disabled: isDisconnect,
        help: buildHelpOption(appStatus),
        tooltipContent: () => isDisconnect && /*#__PURE__*/_jsx(IntegrationDisconnectTooltip, {
          errorLabel: errorLabels[ErrorsType.INTEGRATION_DISCONNECTED_FOR_WEBINAR_FORMS_ERROR],
          appName: appName
        })
      };
    });
  };
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(LabelWithTooltip, {
      labelText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "videoConference.settings.webinarsForm.webinarIntegrationSelect.label"
      }),
      tooltipText: I18n.text('videoConference.settings.webinarsForm.webinarIntegrationSelect.tooltipMessage')
    }),
    children: /*#__PURE__*/_jsx(TooltipSelect, {
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "videoConference.settings.webinarsForm.webinarIntegrationSelect.placeholder.label"
      }),
      options: buildIntegrationOptions(),
      onChange: onWebinarSource,
      value: webinarSource
    })
  });
};
export default IntegrationSelection;